import setGlobalProperty from '@/helpers/setGlobalProperty';

export default {
  install(app, { i18n }) {
    setGlobalProperty(app, '$tOr', (key, fallback) => {
      const result = i18n.t(key);

      if (result === key) {
        return fallback;
      }

      return result;
    });
  },
};
